import {Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-tpiq-windows',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tpiq-windows.component.html',
  styleUrl: './tpiq-windows.component.scss'
})
export class TpiqWindowsComponent {
  @Input('windowTitle') title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() dataContext;
  @Input() maximize;
  @Input() right;
  @Output() onCloseWindow: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCall: EventEmitter<any> = new EventEmitter<any>();
  @Output() onWindowMaximize: EventEmitter<any> = new EventEmitter<any>();
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  showBadge = false;
  windowRight = 0;

  constructor(){
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
  }

  ngOnInit(): void {
    this.windowRight = 7;
  }

  closeWindow(){
    this.onCloseWindow.emit({id: this.dataContext.id});
  }

  toggleWindowSize(){
    if (!this.maximize){
      this.showBadge = false;
    }
    this.maximize = !this.maximize;
    if (!this.maximize){
      this.windowRight = this.right;
    }else {
      this.windowRight = 7;
      this.onWindowMaximize.emit({id: this.dataContext.id});
    }
  }
  createVideoCall(){
    this.onCall.emit(this.dataContext);
    this.maximize = false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public reArrangeStyle(){
    if (this.right >= 29){
      this.right = this.right - 23;
    }
    this.windowRight = this.right;
  }

  public maximizeWindow() {
    this.maximize = true;
    this.windowRight = 7;
  }

  public minimizeWindow(){
    this.maximize = false;
    this.windowRight = this.right;
  }

}
